import React, { useState } from 'react';

const styles = {
  container: {
    position: 'relative',
    margin: '12px 0',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid #30363d',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 12px',
    background: '#1c2128',
    fontSize: '12px',
    color: '#8b949e',
  },
  copyBtn: {
    background: 'none',
    border: '1px solid #30363d',
    color: '#8b949e',
    padding: '2px 10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
  },
  pre: {
    margin: 0,
    padding: '16px',
    background: '#0d1117',
    overflow: 'auto',
    fontSize: '14px',
    lineHeight: '1.6',
    fontFamily: '"Courier New", Courier, monospace',
    color: '#ffffff',
    whiteSpace: 'pre',
  },
};

export default function CodeBlock({ code, language = 'java' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span>{language}</span>
        <button style={styles.copyBtn} onClick={handleCopy}>
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <pre style={styles.pre}>{code}</pre>
    </div>
  );
}
